import * as _ from 'lodash';

import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { TeamService } from 'src/app/shared/services/team.service';
import { TeamAddDetailsComponent } from 'src/app/teams/team-add/team-add-details.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'team-add',
  templateUrl: 'team-add.component.html',
})
export class TeamAddComponent implements OnInit, OnDestroy {
  @ViewChild(TeamAddDetailsComponent, { static: true }) teamDetails: TeamAddDetailsComponent;
  private sub: Subscription;
  errorMessage: any;
  saving: boolean;
  dialogIsOpen = false;

  constructor(public dialogRef: MatDialogRef<TeamAddComponent>, private teamService: TeamService) {}
  ngOnInit(): void {
    this.sub = this.teamService.team.subscribe(
      (team) => {
        if (team) {
          this.dialogIsOpen ? this.dialogRef.close(team.id) : (this.dialogIsOpen = true);
        }
        this.dialogIsOpen = true;
      },
      (error) => (this.errorMessage = <any>error)
    );
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }

  save() {
    if (this.teamDetails.isValid) {
      this.saving = true;
      this.teamDetails.saveNewTeam();
    }
  }
}
